import Phaser from "phaser";
import Pqp from "../../3x1010/Pqp";
import MainScene from "./MainScene";
import ProgressBar from "./ProgressBar";
import Tracking from "./Tracking";
import Locale from "../../3x1010/Locale";

export default class Panel3D extends Phaser.GameObjects.Container {
  constructor(scene, callback) {
    super(scene);
    this.clips = [];
    this.callback = callback;
  }

  init() {
    const background = this.scene.add.image(0, 0, "back3d");
    background.setOrigin(0, 0);
    this.add(background);
    this.width = background.width;
    this.height = background.height;
    background.setBlendMode(Phaser.BlendModes.MULTIPLY);
    background.setInteractive();

    /*const fake = this.scene.add.image(0, 0, "fake");
    fake.setOrigin(0, 0);
    this.add(fake);*/

    // Il titoletto
    const txt = this.scene.add.text(0, 0, Locale.g("Panel3D.Title"), { fontFamily: "DIN Next LT Pro", fontSize: "40px", color: this.toHexColor(ProgressBar.COLOR_BACK), align: "center", fixedWidth: this.width });
    this.add(txt);
    txt.y = 32;
    this.txt = txt;

    /*    const txt1 = this.scene.add.text(100, 0, "Attenzione: questa schermata è temporanea e serve solo per mostrare come probabilmente apparirà il widget3D in futuro.", { fontFamily: "DIN Next LT Pro", fontSize: "30px", color: this.toHexColor(ProgressBar.COLOR_BACK), align: "center", fixedWidth: this.width - 200, wordWrap: { width: this.width - 200 } });
    this.add(txt1);
    txt1.y = 900;*/

    jQuery(window).on("resize.plo", this.onResize.bind(this));
  }

  dispatch(type, data) {
    if (this.callback) {
      const e = { type };
      if (!Pqp.isNullOrEmpty(data)) {
        e.data = data;
      }
      this.callback.call(null, e);
    }
  }

  toHexColor(num) {
    let s = num.toString(16);
    while (s.length < 6) {
      s = "0" + s;
    }
    return "#" + s;
  }

  showWidget(data) {
    debugger;
    // Carica da questo url
    // Tracking.URL_KPTS_3D
    //this.show(data);
    const div = jQuery("#template-plotty").clone();
    this.idPlotty = "plotty" + Panel3D.ENUM++;
    div.attr("id", this.idPlotty);
    jQuery(".js-video-holder").append(div);
    this.divPlotty = div;
    const cv = jQuery(MainScene.that.sys.game.canvas);
    const perc = cv.width() / Tracking.WIDTH;
    const dimw = this.width * perc;
    const dimh = this.height * perc;
    const startx = cv.offset().left - jQuery(".video-holder").offset().left;
    const starty = cv.offset().top - jQuery(".video-holder").offset().top;
    div.css({
      width: dimw * 0.9,
      height: dimh * 0.8,
      left: startx + dimw * 0.05,
      top: starty + dimh * 0.1,
    });

    if (Panel3D.data) {
      this.show(Panel3D.data[MainScene.that.lastToShow]);
    } else {
      fetch(Tracking.URL_KPTS_3D)
        .then((response) => response.json())
        .then((data) => {
          Panel3D.data = data;
          this.show(data[MainScene.that.lastToShow]);
        });
    }
  }

  show(data) {
    console.log(data);
    this.plottyData = data;
    console.log(data);
    console.log("SHOW");
    /*    const div = jQuery("#template-plotty").clone();
    this.idPlotty = "plotty" + Panel3D.ENUM++;
    div.attr("id", this.idPlotty);
    jQuery(".js-video-holder").append(div);
    this.divPlotty = div;
    const cv = jQuery(MainScene.that.sys.game.canvas);
    const perc = cv.width() / Tracking.WIDTH;
    const dimw = this.width * perc;
    const dimh = this.height * perc;
    const startx = cv.offset().left - jQuery(".video-holder").offset().left;
    const starty = cv.offset().top - jQuery(".video-holder").offset().top;
    div.css({
      width: dimw * 0.9,
      height: dimh * 0.8,
      left: startx + dimw * 0.05,
      top: starty + dimh * 0.1,
    });*/

    //div.css("width",)

    requestAnimationFrame(this.initPlotty.bind(this, this.idPlotty, data));
  }

  onResize() {
    this.killWidget();
    clearTimeout(this.idto);
    this.idto = setTimeout(this.showWidget.bind(this, this.plottyData), 100);
  }

  killWidget() {
    console.log("KILL");
    if (this.divPlotty) {
      Plotly.purge(this.idPlotty);
      this.divPlotty.remove();
      this.divPlotty = null;
    }
    //
  }

  kill() {
    jQuery(window).off("resize.plo");
  }

  initPlotty(id, points) {
    jQuery(".load-plotty", this.divPlotty).remove();
    /*    const trace1 = {
      x: [1, 2, 3, 4],
      y: [10, 15, 13, 17],
      z: [10, 15, 13, 107],
      mode: "markers",
      type: "scatter3d",
      name: "Team B",
      text: ["B-a", "B-b", "B-c", "B-d", "B-e"],
      textfont: {
        family: "Times New Roman",
      },
      textposition: "bottom center",
      marker: { size: 12 },
    };

    const trace2 = {
      x: [2, 3, 4, 5],
      y: [16, 5, 11, 9],
      z: [10, 15, 103, 17],
      mode: "lines",
      type: "scatter3d",
    };

    const trace3 = {
      x: [1, 2, 3, 4],
      y: [12, 9, 15, 12],
      z: [100, 15, 13, 17],
      mode: "lines+markers",
      type: "scatter3d",
    };*/

    const a = [];
    const lines = Panel3D.LINES;
    for (let x = 0; x < lines.length; x++) {
      const el0 = points[lines[x][0]];
      const el1 = points[lines[x][1]];
      const o = {
        x: [el0[0], el1[0]],
        y: [el0[1], el1[1]],
        z: [el0[2], el1[2]],
        mode: "lines",
        type: "scatter3d",
      };
      a.push(o);
    }

    const data = a;
    /*
    const layout = {
      xaxis: {
        range: [0.75, 5.25],
      },
      yaxis: {
        range: [0, 8],
      },
      autosize: true,
      showlegend: false,
      hiddenlabels: true,
    };*/

    const layout = Tracking.data.layout3d;

    try {
      Plotly.react(id, data, layout, { displayModeBar: false });
    } catch (e) {
      //
    }
  }
}

Panel3D.ENUM = 0;

// [-1, 0, 1, 2, 0, 4, 5, 0, 7, 8, 8, 10, 11, 8, 13, 14]
Panel3D.LINES = [
  [0, 1],
  [1, 2],
  [2, 3],
  [0, 4],
  [4, 5],
  [5, 6],
  [0, 7],
  [7, 8],
  [8, 9],
  [8, 10],
  [10, 11],
  [11, 12],
  [8, 13],
  [13, 14],
  [14, 15],
];
